import moment from "moment";
import { ItemArquivo } from "./ItemArquivo";
import { ItemArquivoLink } from "./ItemArquivoLink";

export function ItemArquivos({ arquivos, id }) {
  return (
    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
      <dt className="text-sm/6 font-medium text-gray-900">Arquivos</dt>
      <dd className="mt-2 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
        <ul role="list" className="divide-y divide-gray-100 rounded-md border border-gray-200">
          {arquivos.map((item, idx) => (
            item.type === "arquivo_link" ? (
              <ItemArquivoLink id={id} link={item.resposta} key={idx} originalname={item.originalname} size={item.size} hora={moment(item.createdAt).format("DD/MM/YYYY HH:mm")} />
            ) : (
              <ItemArquivo base64String={item.resposta} key={idx} originalname={item.originalname} size={item.size} hora={moment(item.createdAt).format("DD/MM/YYYY HH:mm")} />
            )
          ))}
        </ul>
      </dd>
    </div>
  )
}